import { csx } from '@vtex/admin-ui'

export const styles = {
  selectorHeader: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
  }),
  selectorHeaderIcon: csx({
    color: '$secondary',
  }),
}
